
// 
function PreferenceContainer(props) {
    return (
        <div className="cmp-card mb-40 mb-lg-4">
            {props.children}
        </div>
    )
}

export default PreferenceContainer;